export default "__VITE_ASSET__DOc1TQEK__"